import React from "react";
import { Line, Legend } from "recharts";
import { EMCURE_PIE_COLORS } from "./emcureChartConstants";

/**
 * One or more comparison lines (e.g. March vs April by division).
 */
export default function ChartSeriesLines({
  seriesKeys,
  strokeWidth = 3,
  dotRadius = 4,
  showLegend = true,
}) {
  if (!seriesKeys?.length) return null;

  return (
    <>
      {seriesKeys.map((sk, i) => {
        const color = EMCURE_PIE_COLORS[i % EMCURE_PIE_COLORS.length];
        return (
          <Line
            key={sk.dataKey}
            type="monotone"
            dataKey={sk.dataKey}
            name={sk.label}
            stroke={color}
            strokeWidth={strokeWidth}
            dot={{ fill: color, r: dotRadius }}
            activeDot={{ r: dotRadius + 2 }}
            isAnimationActive={false}
            connectNulls
          />
        );
      })}
      {showLegend ? (
        <Legend
          wrapperStyle={{ fontSize: 12, fontWeight: 600, paddingTop: 8 }}
          iconType="line"
        />
      ) : null}
    </>
  );
}
